import React from 'react';

import { Link } from '@commons/link/Link';

import cloudNativeIcon from '@images/spe-cloud/cloud-native.svg';

export const cloudNative = {
  mainSection: {
    icon: cloudNativeIcon,
    elements: [
      {
        type: 'text',
        items: [
          <>
            <Link href="/glossary/cloud-native/">Cloud-native</Link> is an approach to building scalable applications
            and running them in a public, private, hybrid or multi-cloud environment.
          </>,
          <></>,
          <>
            Companies build and operate cloud-native applications to quickly address customer needs and shorten the
            time-to-market of new ideas.
          </>,
        ],
      },
      {
        type: 'list',
        description: 'The business benefits of cloud-native apps include:',
        items: [
          <>Scalability—apps designed and built explicitly for the cloud can be scaled easily (in and out)</>,
          <>
            Reliability—fault tolerance increases thanks to the microservice approach and distributed implementation.
          </>,
          <>Flexibility—cloud-native design lets you forget about cloud vendor lock-in.</>,
          <>
            Cost optimization—services can be released faster and on resources tailored to match an app’s requirements.
          </>,
          <>
            Ease of access—the cloud makes apps accessible from anywhere with nothing more than an internet connection.
          </>,
          <>Stability—overloading an app in the cloud is nearly impossible.</>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        description: 'Build your cloud-native application with us. Our services include:',
        items: [
          <>Cloud-native solution architecture</>,
          <>Moving on-prem apps to the cloud (lift and shift)</>,
          <>Deployment orchestration</>,
          <>Full stack development of cloud-native apps:</>,
          {
            listType: 'nested',
            item: <>UX and UI</>,
          },
          {
            listType: 'nested',
            item: <>CI/CD custom builds</>,
          },
          {
            listType: 'nested',
            item: <>Automated tests and QA</>,
          },
          <>Performance analysis and troubleshooting</>,
          <>Support and maintenance</>,
          <>Ensuring security and proper monitoring of cloud-native solutions</>,
          <>Cloud services management</>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Case study',
        items: [
          {
            title: 'Building a microservices security platform',
            link: '/case-study/building-microservices-security-platform/',
          },
        ],
      },
      {
        type: 'Blog posts',
        items: [
          {
            title: 'Day 0/Day 1/Day 2 - the software lifecycle in the cloud age',
            link: '/blog/day-0-day-1-day-2-the-software-lifecycle-in-the-cloud-age/',
          },
          {
            title: 'How to build a test automation framework in the cloud',
            link: '/blog/how-to-build-a-test-automation-framework-in-the-cloud/',
          },
          {
            title: 'Six reasons you may need a Managed Cloud Service Provider',
            link: '/blog/six-reasons-you-may-need-a-managed-cloud-service-provider/',
          },
        ],
      },
    ],
  },
};
